import React, { useState, useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import outer_eclipse from "../../assets/Images/cancelled_outer.png";
import outer_eclipse_svg from "../../assets/Images/cancelled_outer.svg";
import money_off from "../../assets/Images/money_off.png";
import subcr_info from "../../assets/Images/guac_subcr_info.svg";

import SubscriptionFeedback from "./SubscriptionFeedback";
import {
  useFeedbacks,
  useFintechSubscriptions,
  useSubscriptionPurchaseMutation,
  useSubscriptionsPlans,
  useActiveSubscriptions,
  useFintechLayouts,
} from "../../services/AsaApiServices";
import { useNavigate, useLocation } from "react-router-dom";
import { AsaStateContext } from "../../components/AsaStateProvider";
import { useAsaSession, useAsaSessionPagesMutation } from "../../services/AsaSessionServices";
import { useBackButton } from "../../services/AsaSessionServices";
import SubscriptionManagementBase from "./SubscriptionManagementBase";
import { IAsaSession, SessionPage } from "../../types/types";
import { showCustomToast } from "../../services/toastService";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";

const infoIcon = (isDarkMode:boolean) => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <rect width="24" height="24" fill={isDarkMode ?"#2C2C2C" : "#D9D9D9"}/>
  <g >
    <path d="M12.0003 16.75C12.2129 16.75 12.391 16.6781 12.5345 16.5343C12.6782 16.3906 12.75 16.2125 12.75 16V11.75C12.75 11.5375 12.6781 11.3593 12.5343 11.2155C12.3904 11.0718 12.2122 11 11.9998 11C11.7871 11 11.609 11.0718 11.4655 11.2155C11.3218 11.3593 11.25 11.5375 11.25 11.75V16C11.25 16.2125 11.3219 16.3906 11.4658 16.5343C11.6096 16.6781 11.7878 16.75 12.0003 16.75ZM12 9.2885C12.2288 9.2885 12.4207 9.21108 12.5755 9.05625C12.7303 8.90142 12.8077 8.70958 12.8077 8.48075C12.8077 8.25192 12.7303 8.06008 12.5755 7.90525C12.4207 7.75058 12.2288 7.67325 12 7.67325C11.7712 7.67325 11.5793 7.75058 11.4245 7.90525C11.2697 8.06008 11.1923 8.25192 11.1923 8.48075C11.1923 8.70958 11.2697 8.90142 11.4245 9.05625C11.5793 9.21108 11.7712 9.2885 12 9.2885ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5Z" fill={isDarkMode ? "white" :"#4E4E4E"}/>
  </g>
</svg>
  )

 const outerCircle = (isDarkMode:boolean) => ( 
<svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter id="blur">
      <feGaussianBlur in="SourceGraphic" stdDeviation="8" />
    </filter>
  </defs>
  <circle cx="100" cy="100" r="78" stroke="#D8D8D8" stroke-width="3"  fill="none"  opacity="1" />
  <circle cx="100" cy="100" r="82" stroke={isDarkMode ? "#D8D8D8": "#2C2C2C"} stroke-width="5"  fill="none" filter="url(#blur)" opacity="0.9" />

</svg>
 )
const ReactivatePlanScreen = () => {
  const { t,i18n } = useTranslation();
  const navigate = useNavigate();

  const { data: session } = useAsaSession();

  const sessionMutation = useAsaSessionPagesMutation();
  const location = useLocation();
  const { state: navigatestate } = location;
  const cancelCode = navigatestate?.code;
  const fintechSubscriptions = useFintechSubscriptions();
  const { data: subscriptionsPlans } = useSubscriptionsPlans();
  const subscriptionToReactivate = Array.isArray(fintechSubscriptions?.data)
    ? fintechSubscriptions?.data?.find((x) => x.billingDetailCode == cancelCode)
    : undefined;
  const feedbacksquery = useFeedbacks();
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);

  const [state, ] = useContext(AsaStateContext);
  const activeSubscriptions = useActiveSubscriptions();
  const activeSubscription = Array.isArray(activeSubscriptions?.data) ? activeSubscriptions?.data?.[0] : undefined;
  const backButton = useBackButton();
  const [isAlreadyFeedback, setIsAlreadyFeedback] = useState(true);
  const fintechLaoyut = useFintechLayouts();
  const subscriptionPurchaseMutation = useSubscriptionPurchaseMutation();
  const [isReactivatePlan, setIsReactivatePlan] = useState(false);

  const isShowMoneyIcon=false;
  const isShowPlanStatus=false;
  

  useEffect(() => {
    if (!feedbacksquery.isLoading && feedbacksquery.isSuccess && feedbacksquery.data && feedbacksquery.data.length === 0) {
      setIsAlreadyFeedback(false);
    }
  }
  , [feedbacksquery.isLoading, feedbacksquery.data]);
  useEffect(() => {
    AnalyticsService.track("Reactivate Plan Viewed", AnalyticsAction.View, AnalyticsFeature.Payment, {
      subscriptionName: subscriptionToReactivate?.subscriptionTitle,
      price: subscriptionToReactivate?.recurringAmount,
    });
  }, []);

  useEffect(() => {
    if (location.pathname === "/cancelledfeedback") {
      setFeedbackOpen(true);
    } else {
      setFeedbackOpen(false);
    }

  }, [location]);
  useEffect(() => {
    try {

      if (
        (!!activeSubscription && !activeSubscriptions.isLoading && !isReactivatePlan)
        || !!!cancelCode
      ) {
        if (!!state.url) {
          const currentUrl = new URL(state.url);

          navigate(currentUrl.pathname);
        } else {
          backButton();
        }

      }
    } catch (error) {
      console.log("error in subscription management", error);
    }
  }, [activeSubscription, activeSubscriptions.isLoading, state?.url, cancelCode]);

  const onNavigateBack = () => {
    if (location.pathname === "/cancelledfeedback") {
      navigate(-1);
    }
    if (isFeedbackOpen) {
      setFeedbackOpen(false);
      return;
    }
    if (!!state.url) {
      const currentUrl = new URL(state.url);
      navigate(currentUrl.pathname);
    }
  };
  const formatDate = (dateString: string | number | Date) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric", // Correctly typed as 'numeric'
      month: "long", // Correctly typed as 'long'
      day: "numeric", // Correctly typed as 'numeric'
    };
    const localeToUse = i18n.language || "en-US"; // Default to 'en-US' if locale is undefined
    return new Date(dateString).toLocaleDateString(localeToUse, options);
  };
  const endDateMsg=state?.cancelPlanDate ? formatDate(state.cancelPlanDate) :subscriptionToReactivate?.subscriptionEndDate
                      ? formatDate(subscriptionToReactivate?.subscriptionEndDate)
                      : t("subscriptionEndDate")
  const msgTitle=state?.reactivateHeaderText ? state?.reactivateHeaderText  : t(
                    subscriptionToReactivate?.inTrial
                      ? "freeTrialWillEndOn"
                      : "currentPlanWillEndOn"
                  );
  const msgDetail=state?.reactivateBodyText? state?.reactivateBodyText:t("noAccessAfterEndDate")
  const saveFreeSubscription = async () => {

    try {
      const requestData = {
        comment: "Free Plan",
        billingEmail: null,
        isAcceptTerms: true,
        firstName: null,
        middleName: null,
        lastName: null,
        subscriptionPlanCode: subscriptionToReactivate?.subscriptionPlanCode,
        address: null,
        address2: null,
        city: null,
        state: null,
        country: null,
        postalCode: null,
        couponCode: null,
      };
      await subscriptionPurchaseMutation.mutateAsync(requestData);
      AnalyticsService.track("Reactivate Free Plan Success", AnalyticsAction.API_Result, AnalyticsFeature.Payment, {
        subscriptionName: subscriptionToReactivate?.subscriptionTitle,
      });
      setIsReactivatePlan(true);
      let successDynamicLink = null;
      const targetPage = session?.sessionPages?.find((page) => page.pageNumber === 0);
      if (targetPage) {
        const pageData = JSON.parse(targetPage.pageData);
        successDynamicLink = pageData.successDynamicLink;
      }


      if (successDynamicLink) {
        window.location.href = successDynamicLink;
      } else {
        console.error("Back action dynamic link not found.");
      }
    } catch (error) {
      AnalyticsService.track("Reactivate Free Plan Error", AnalyticsAction.API_Result, AnalyticsFeature.Payment, {
        subscriptionName: subscriptionToReactivate?.subscriptionTitle,
      });
      if (error instanceof Error) {
        showCustomToast(error.message, true);
      } else {
        showCustomToast("Error select subscriptions", true);
      }

    }
  }
  const handleReactivate = async () => {
    AnalyticsService.track("Reactivate Plan Clicked", AnalyticsAction.Click, AnalyticsFeature.Payment, {
      subscriptionName: subscriptionToReactivate?.subscriptionTitle,
      price: subscriptionToReactivate?.recurringAmount,
    });
    const sessionToUpdate = { ...session } as IAsaSession;
    sessionToUpdate.sessionPages = undefined;
    const sessionpages = [];
    const selectedPlan = subscriptionsPlans?.find(
      (x) => x.subscriptionPlanCode === subscriptionToReactivate?.subscriptionPlanCode
    );
    const firstPage = session?.sessionPages?.find((page) => page.pageNumber === 0);

    if (selectedPlan?.isFree) {
      await saveFreeSubscription();
      return;
    }

    if (selectedPlan) {
      const selectPackagePage: SessionPage = {
        pageNumber: 2,
        pageName: "GOALS PLANS",
        pageTitle: "Select Package",
        pageDescription: "Select Package",
        pageUrl: firstPage?.pageUrl ?? "/moneypatrol",
        pageStatusMessage: "INCOMPLETE",
        pageData: JSON.stringify(selectedPlan),
      } as SessionPage;
      sessionpages.push(selectPackagePage);
    }

    const response = await sessionMutation.mutateAsync({
      asaSession: sessionToUpdate,
      extraPages: sessionpages,
    });

    navigate("/subscriptionpayment");
  };

  return (
    <SubscriptionManagementBase onNavigateBack={onNavigateBack}>
      {!isFeedbackOpen && (
        <div className="flex flex-col flex-grow justify-between h-full">
          <div className="flex-grow flex flex-col justify-center items-center mt-4 px-4">
              {/* Icon Section */}
              {isShowMoneyIcon && 
                <div className="flex items-center justify-center">
                  <div className="relative p-4 rounded-full">
                    {outerCircle(state.isDarkMode)}
                    <img
                      src={money_off}
                      alt="Money Card"
                      className="absolute inset-0 h-16 w-16 m-auto p-2"
                    />
                  </div>
                </div>
              }
              {isShowPlanStatus &&
              <>
                  <p className="text-[#DF4949] text-center font-poppins text-[14px] font-semibold leading-[20px] tracking[-0.1px] mb-3">
                    <span className="mr-2">•</span>{t("canceled")}
                  </p>

                  <h1 className="text-xl  font-semibold">
                    {subscriptionToReactivate?.subscriptionTitle}
                  </h1>
              </>
              }
              {/* Trial end date */}
              <div className="dark:bg-[#2C2C2C] bg-[#D9D9D9]  rounded-lg p-2 relative mt-4 flex flex-col items-center">
                <div className="absolute top-2 left-2">
                  {infoIcon(state.isDarkMode)}
                </div>

                <div className="overflow-hidden text-center">
                  <p className="text-center font-poppins text-sm font-semibold leading-6 tracking-[-0.1px] mt-4">
                    {msgTitle}
                  </p>
                  <p className=" text-center font-poppins text-sm font-semibold leading-6 tracking-[-0.1px]">
                    {endDateMsg}
                  </p>

                  <p className="dark:text-white dark:opacity-50 text-[#4E4E4E] text-center font-poppins text-sm font-normal leading-5 tracking-[-0.1px]">
                    {msgDetail}
                  </p>
                  {!isAlreadyFeedback &&
                    <p className="dark:text-white dark:opacity-50 text-[#4E4E4E] text-center font-poppins text-sm font-normal leading-5 tracking-[-0.1px]">
                      {t("helpImproveSurvey")}
                    </p>
                  }
                  {!isAlreadyFeedback && (
                    <button
                      className="mt-4 w-[162px] h-[42px] flex-shrink-0 
                       font-poppins text-[14px] font-semibold 
                      leading-[20px] tracking[-0.1px] 
                      text-center rounded-[10px]
                      dark:border-white border-[#4E4E4E]
                      border-solid border rounded-lg border-0
                      dark:bg-[#4E4E4E] bg-[#B7B7B7] dark:text-white text-black"
                      style={{ textTransform: "capitalize" }}
                      onClick={() =>
                        navigate("/cancelledfeedback", {
                          state: { code: cancelCode },
                        })
                      }
                    >
                      {t("giveFeedback")}
                    </button>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex w-full mt-1 mb-1 flex-col flex-1 justify-end items-center gap-4">
                <button
                  onClick={handleReactivate}
                  className="bg-[#46B601] rounded-[10px] shadow-[0_4px_4px_rgba(0,0,0,0.25)] text-white p-2.5 text-sm font-semibold capitalize w-full  h-[51px]"
                  style={fintechLaoyut?.buttonStyle}
                >
                  <span className="text-white text-[16px] text-center font-poppins font-bold leading-5 tracking-[-0.1px] uppercase">
                    {t("reactivatePlan")}
                  </span>
                </button>
              </div>
            </div>

        </div>
      )}
      {isFeedbackOpen && (
        <SubscriptionFeedback
          onSubmitFeedback={() => {
            navigate(-1);
            setIsAlreadyFeedback(true);
          }}
          subScriptionPlanCode={subscriptionToReactivate?.subscriptionPlanCode}
        />
      )}
    </SubscriptionManagementBase>
  );
};

export default ReactivatePlanScreen;
